import {
  Chart as ChartJS,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js'

let registered = false

export const registerChartComponents = () => {
  if (registered) return
  ChartJS.register(
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    LineController,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Title
  )
  registered = true
}
